<rt-icons-container></rt-icons-container>
<div class="app-container" cdkScrollable>
  <div>
    <rt-input [formControl]="htmlInput" placeholder="Paste HTML"></rt-input>
    <rt-wysiwg
      [formControl]="formControl"
      [config]="ProsemirrorConfig.Default"
      [maxHeight]="'50vh'"
    ></rt-wysiwg>
  </div>
  <div>
    <div
      [prosemirrorRender]="exampleInitial"
      [prosemirrorRenderConfig]="ProsemirrorConfig.Default"
    ></div>
  </div>
  <div layout>
    <rt-button #buttonComponent variant="primary" (click)="openEmojiPicker(buttonComponent.elRef)"
      >Open emoji picker</rt-button
    >
    <span> Selected emoji: {{ selectedEmoji }} </span>
  </div>
  <div [innerHTML]="'Test 😃 abcc 👩‍🚀 uuu 🧑‍🚀 oo 🤔🙂🤔🙂' | emojiFallbackHtml | rtSafeHtml"></div>
</div>
